import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderBiblicalGuideForgiveness from "../../../../src/content/biblical-guide-to-forgiveness/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderBiblicalGuideForgiveness,
  React
};